import "../assets/index-9020d9ca.css";
import s from "./NcDateTimePicker.mjs";
import n from "./NcDateTimePickerNative.mjs";
import r from "./NcPasswordField.mjs";
import o from "./NcSelect.mjs";
import c from "./NcTextField.mjs";
import { A as u } from "../chunks/actionGlobal-8c1c28c9.mjs";
import { G as l } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { t as d } from "../chunks/l10n-ef44019c.mjs";
import { n as p } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const b = {
  name: "NcActionInput",
  components: {
    NcDateTimePicker: s,
    NcDateTimePickerNative: n,
    NcPasswordField: r,
    NcSelect: o,
    NcTextField: c
  },
  mixins: [u],
  props: {
    /**
     * id attribute of the checkbox element
     */
    id: {
      type: String,
      default: () => "action-" + l(),
      validator: (e) => e.trim() !== ""
    },
    /**
     * id attribute of the text input element
     */
    inputId: {
      type: String,
      default: () => "action-input-" + l(),
      validator: (e) => e.trim() !== ""
    },
    /**
     * Icon to show with the action, can be either a CSS class or an URL
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * type attribute of the input field
     */
    type: {
      type: String,
      default: "text",
      validator(e) {
        return [
          "date",
          "datetime-local",
          "month",
          "multiselect",
          "number",
          "password",
          "search",
          "tel",
          "text",
          "time",
          "url",
          "week",
          "color",
          "email"
        ].indexOf(e) > -1;
      }
    },
    /**
     * id attribute for the native date time picker
     */
    idNativeDateTimePicker: {
      type: String,
      default: "date-time-picker_id"
    },
    /**
     * Flag to use a native date time picker
     */
    isNativePicker: {
      type: Boolean,
      default: !1
    },
    /**
     * The visible input label for accessibility purposes.
     */
    label: {
      type: String,
      default: null
    },
    /**
     * If you want to show the label just above the
     * input field, pass in `true` to this prop.
     */
    labelOutside: {
      type: Boolean,
      default: !0
    },
    /**
     * value attribute of the input field
     */
    value: {
      type: [String, Date, Number, Array],
      default: ""
    },
    /**
     * disabled state of the input field
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * aria-label attribute of the input field
     */
    ariaLabel: {
      type: String,
      default: ""
    },
    /**
     * @deprecated To be removed in @nextcloud/vue 9. Migration guide: remove ariaHidden prop from NcAction* components.
     * @todo Add a check in @nextcloud/vue 9 that this prop is not provided,
     * otherwise root element will inherit incorrect aria-hidden.
     */
    ariaHidden: {
      type: Boolean,
      default: null
    },
    /**
     * Attribute forwarded to the underlying NcPasswordField and NcTextField
     */
    showTrailingButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Trailing button label forwarded to the underlying NcTextField
     */
    trailingButtonLabel: {
      type: String,
      default: d("Submit")
    }
  },
  emits: [
    "input",
    "submit",
    "change",
    "update:value"
  ],
  computed: {
    isIconUrl() {
      try {
        return new URL(this.icon);
      } catch {
        return !1;
      }
    },
    isMultiselectType() {
      return this.type === "multiselect";
    },
    nativeDatePickerType() {
      switch (this.type) {
        case "date":
        case "month":
        case "time":
        case "week":
        case "datetime-local":
          return this.type;
      }
      return !1;
    },
    datePickerType() {
      if (!this.isNativePicker)
        switch (this.type) {
          case "date":
          case "month":
          case "time":
            return this.type;
          case "datetime-local":
            return "datetime";
        }
      return !1;
    },
    /**
     * determines if the action is focusable
     *
     * @return {boolean} is the action focusable ?
     */
    isFocusable() {
      return !this.disabled;
    }
  },
  methods: {
    // closing datepicker popup on mouseleave = unfocus
    onLeave() {
      this.$refs.datetimepicker && this.$refs.datetimepicker.$refs.datepicker && this.$refs.datetimepicker.$refs.datepicker.closePopup();
    },
    onInput(e) {
      this.$emit("input", e), this.$emit("update:value", e.target ? e.target.value : e);
    },
    onSubmit(e) {
      if (e.preventDefault(), e.stopPropagation(), !this.disabled)
        this.$emit("submit", e);
      else
        return !1;
    },
    onChange(e) {
      this.$emit("change", e);
    }
  }
};
var m = function() {
  var t = this, i = t._self._c;
  return i("li", { staticClass: "action", class: { "action--disabled": t.disabled } }, [i("span", { staticClass: "action-input", class: {
    "action-input-picker--disabled": t.disabled,
    "action-input--visible-label": t.labelOutside && t.label
  }, on: { mouseleave: t.onLeave } }, [i("span", { staticClass: "action-input__icon-wrapper" }, [t._t("icon", function() {
    return [i("span", { staticClass: "action-input__icon", class: [t.isIconUrl ? "action-input__icon--url" : t.icon], style: { backgroundImage: t.isIconUrl ? `url(${t.icon})` : null }, attrs: { "aria-hidden": "true" } })];
  })], 2), i("form", { ref: "form", staticClass: "action-input__form", attrs: { disabled: t.disabled }, on: { submit: function(a) {
    return a.preventDefault(), t.onSubmit.apply(null, arguments);
  } } }, [i("div", { staticClass: "action-input__container" }, [t.label && t.labelOutside ? i("label", { staticClass: "action-input__text-label", class: { "action-input__text-label--hidden": !t.labelOutside }, attrs: { for: t.inputId } }, [t._v(" " + t._s(t.label) + " ")]) : t._e(), i("div", { staticClass: "action-input__input-container" }, [t.datePickerType ? i("NcDateTimePicker", t._b({ ref: "datetimepicker", staticClass: "action-input__datetimepicker", staticStyle: { "z-index": "99999999999" }, attrs: { value: t.value, placeholder: t.text, disabled: t.disabled, type: t.datePickerType, "input-class": ["mx-input", { focusable: t.isFocusable }] }, on: { input: t.onInput, change: t.onChange } }, "NcDateTimePicker", t.$attrs, !1)) : t.isNativePicker ? i("NcDateTimePickerNative", t._b({ staticClass: "action-input__datetimepicker", attrs: { id: t.idNativeDateTimePicker, value: t.value, type: t.nativeDatePickerType, "input-class": { focusable: t.isFocusable } }, on: { input: function(a) {
    return t.$emit("input", a);
  }, change: function(a) {
    return t.$emit("change", a);
  } } }, "NcDateTimePickerNative", t.$attrs, !1)) : t.isMultiselectType ? i("NcSelect", t._g(t._b({ staticClass: "action-input__multi", attrs: { value: t.value, placeholder: t.text, disabled: t.disabled, "append-to-body": !1, "input-class": { focusable: t.isFocusable } } }, "NcSelect", t.$attrs, !1), t.$listeners)) : t.type === "password" ? i("NcPasswordField", t._g(t._b({ attrs: { id: t.inputId, value: t.value, label: t.label, "label-outside": !t.label || t.labelOutside, placeholder: t.text, disabled: t.disabled, "input-class": { focusable: t.isFocusable }, "show-trailing-button": t.showTrailingButton && !t.disabled }, on: { input: t.onInput, change: t.onChange } }, "NcPasswordField", t.$attrs, !1), t.$listeners)) : t.type === "color" ? i("div", { staticClass: "action-input__container" }, [t.label && t.type === "color" ? i("label", { staticClass: "action-input__text-label", class: { "action-input__text-label--hidden": !t.labelOutside }, attrs: { for: t.inputId } }, [t._v(" " + t._s(t.label) + " ")]) : t._e(), i("div", { staticClass: "action-input__input-container" }, [i("NcColorPicker", t._g(t._b({ staticClass: "colorpicker__trigger", attrs: { id: "inputId", value: t.value }, on: { input: t.onInput, submit: function(a) {
    return t.$refs.form.requestSubmit();
  } } }, "NcColorPicker", t.$attrs, !1), t.$listeners), [i("button", { staticClass: "colorpicker__preview", class: { focusable: t.isFocusable }, style: { "background-color": t.value } })])], 1)]) : i("NcTextField", t._g(t._b({ attrs: { id: t.inputId, value: t.value, label: t.label, "label-outside": !t.label || t.labelOutside, placeholder: t.text, disabled: t.disabled, "input-class": { focusable: t.isFocusable }, type: t.type, "trailing-button-icon": "arrowRight", "trailing-button-label": t.trailingButtonLabel, "show-trailing-button": t.showTrailingButton && !t.disabled }, on: { "trailing-button-click": function(a) {
    return t.$refs.form.requestSubmit();
  }, input: t.onInput, change: t.onChange } }, "NcTextField", t.$attrs, !1), t.$listeners))], 1)])])])]);
}, f = [], _ = /* @__PURE__ */ p(
  b,
  m,
  f,
  !1,
  null,
  "48dfde24",
  null,
  null
);
const T = _.exports;
export {
  T as default
};
